
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetAllSeatplanOptions,
  GetAllfacilityOptions,
  GetById
} from "adminApi/HallRoomTypeApi/HallRoomType";
import { validateForm } from "utils/validation";
import { HallTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditHallRoomTypeForm from "./Componates/EditHallRoomTypeForm";
import fields from "../json/HallRoomTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditHallRoomType = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const { id } = useParams();

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    HallTypeRules
  );

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  //Get Seatplan Types
  const {
    data: SeatplanOptions,
    loading: loadingSeatplanOptions
  } = useFetchAllData(
    GetAllSeatplanOptions
  );

  //Get facility Types
  const {
    data: facilityOptions,
    loading: loadingfacilityOptions
  } = useFetchAllData(
    GetAllfacilityOptions
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();

      // remove preview-only field
      delete formValues.imagePreview;

      // convert array to JSON
      if (Array.isArray(formValues.facility_id)) {
        formData.append(
          "facility_id",
          JSON.stringify(formValues.facility_id)
        );
      }

      Object.entries(formValues).forEach(([key, val]) => {
        if (key === "facility_id") return;
        formData.append(key, val ?? "");
      });
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, HallTypeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Updated Hall Room Type successfully"
  );

  return (
    <>
      {
        (
          loadingSubmit ||
          loadingSeatplanOptions ||
          loadingfacilityOptions ||
          loadingFetch
        ) && <Spinner isSpinner={true} />}
      <EditHallRoomTypeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Update Hall Seat Plan"
        handleFileChange={handleFileChange}
        formdata={formdata}
        SeatplanOptions={SeatplanOptions}
        setValues={setValues}
        facilityOptions={facilityOptions}
      />
    </>
  );
};

export default EditHallRoomType;
